export default __webpack_public_path__ + "59780a09a062a6c11491af5b6a7436e0.png";